import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "src/common/components/Navigation/Navigation";

const AgentsWrapper = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isDetail = /\/agents\/\d+/.test(location.pathname);
  const isNew = location.pathname.endsWith("/new");
  const isSettings = location.pathname.endsWith("/settings");
  const isListOrDocuments = !isDetail && !isNew && !isSettings;

  let title = t("pages.agents.title");
  if (isNew) title = t("pages.agents.createAgent");
  if (isSettings) title = t("pages.agents.agentSettings");

  const tabs = isListOrDocuments
    ? [
        { title: t("pages.agents.agentsTab"), urlEndPoint: "/agents/list" },
        { title: t("pages.agents.documentsTab"), urlEndPoint: "/agents/documents" },
      ]
    : undefined;

  return (
    <>
      <Navigation
        title={title}
        showGoBackButton={isDetail || isNew || isSettings}
        backCustomRedirectTo={isSettings ? undefined : "/agents"}
        tabs={tabs}
      />
      <div className="h-full flex flex-col bg-gray-50 overflow-hidden">
        <div className="flex-1 min-h-0 p-4 flex flex-col">
          <div className="flex-1 min-h-0">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentsWrapper;
